<template>
  <div>
    <el-button
      type="primary"
      icon="el-icon-plus"
      @click="createEnv">新建{{ envName }}</el-button>
    <trace-info-modal
      ref="modal"
      :vendorId="userInfo.orgId"
      :envInfoType="envInfoType"
      :envName="envName"
      :fetch="fetchList" />
  </div>
</template>

<script>
import TraceInfoModal from '../trace-info-modal.vue'
import { mapState } from 'vuex'
export default {
  name: 'CreateTraceinfoBtn',
  components: { TraceInfoModal },
  props: {
    envInfoType: Number,
    envName: String,
    fetch: Function
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  watch: {},
  created() { },
  mounted() { },
  methods: {
    createEnv() {
      this.$refs.modal.toggleModal(true)
    },
    fetchList() {
      this.fetch && this.fetch()
    }
  }
}
</script>
<style lang="stylus" scoped></style>
